
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ExternalLink, HelpCircle, Key, Lock } from 'lucide-react';

const ApiKeyGuide = () => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <HelpCircle className="w-5 h-5 text-youtube-red" />
          Comment obtenir une clé API YouTube
        </CardTitle>
        <CardDescription>
          Guide étape par étape pour créer votre propre clé API YouTube
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ol className="list-decimal pl-5 space-y-4">
          <li>
            <p className="font-medium">Créez un projet Google Cloud</p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Rendez-vous sur la <a 
                href="https://console.cloud.google.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-700 inline-flex items-center gap-1"
              >
                console Google Cloud <ExternalLink className="w-3 h-3" />
              </a> et créez un nouveau projet.
            </p>
          </li>
          
          <li>
            <p className="font-medium">Activez l'API YouTube Data</p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Dans votre projet, accédez à "APIs & Services" {'->'} "Library", recherchez "YouTube Data API v3" et activez-la.
            </p>
          </li>
          
          <li>
            <p className="font-medium">Créez une clé API</p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Allez dans "APIs & Services" {'->'} "Credentials" {'->'} "Create credentials" {'->'} "API key".
            </p>
          </li>
          
          <li>
            <p className="font-medium">Restreignez votre clé API (recommandé)</p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Pour plus de sécurité, vous pouvez restreindre votre clé API à l'API YouTube Data uniquement.
            </p>
          </li>
          
          <li>
            <p className="font-medium">Copiez et collez votre clé API</p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Copiez la clé API générée et collez-la dans le champ "Clé API YouTube" ci-dessus.
            </p>
          </li>
        </ol>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-md p-4 mt-4">
          <div className="flex items-start">
            <Lock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
            <div>
              <h4 className="font-medium text-blue-700 dark:text-blue-400">Sécurité et confidentialité</h4>
              <p className="text-sm text-blue-600 dark:text-blue-300 mt-1">
                Votre clé API est stockée en toute sécurité dans notre base de données et n'est utilisée que par vous. 
                Nous ne la partageons avec personne d'autre.
              </p>
            </div>
          </div>
        </div>
        
        <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">
          <p>
            Pour plus d'informations sur les quotas de l'API YouTube, consultez la <a 
              href="https://developers.google.com/youtube/v3/getting-started#quota" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-blue-700 inline-flex items-center gap-1"
            >
              documentation officielle <ExternalLink className="w-3 h-3" />
            </a>.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApiKeyGuide;
